var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learnList"},[_c('div',{staticClass:"learnMore"},[_c('span',{on:{"click":_vm.enterLearnMore}},[_vm._v("更多")]),_c('i',{staticClass:"el-icon-plus",on:{"click":_vm.enterLearnMore}})]),_c('div',{staticClass:"learn-item-list"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }